// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { FxBreadcrumbs } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import ActionsHeader from './ActionsHeader';
// eslint-disable-next-line no-unused-vars
import ActionsTable from './ActionsTable';
import { defaultFilterData } from './actionsInitData';
// eslint-disable-next-line no-unused-vars
import UpdatePassword from '../../Common/UpdatePassword/UpdatePassword';
// eslint-disable-next-line no-unused-vars
import PageHeader from '../../Common/Headers/PageHeader';
import labels from '../../../constants/labels';
import {
  actionsBreadcrumbs,
  activateFxAccountBreadcrumb,
} from '../../../constants/breadcrumbs';
import actionType from '../../../constants/actionType';

const Actions = () => {
  const [filterData, setFilterData] = useState(_.clone(defaultFilterData));
  const [stepNo, setStepNo] = useState(1);
  const [selectedAction, setSelectedAction] = useState({});

  return (
    <>
      {stepNo === 1 && (
        <>
          <FxBreadcrumbs breadcrumbItems={actionsBreadcrumbs} />
          <PageHeader headerText={labels.MY_ACTIONS} />
          <ActionsHeader
            setFilterData={setFilterData}
            filterData={filterData}
          />
          <ActionsTable
            filterData={filterData}
            setStepNo={setStepNo}
            setSelectedAction={setSelectedAction}
          />
        </>
      )}
      {stepNo === 2 && (
        <UpdatePassword
          selectedFxAccount={{
            reqId: selectedAction?.reqId,
            fxAccountId: selectedAction?.profileId,
            fxAccountName: selectedAction?.entityName,
            password: '',
            confirmPassword: '',
            environment: selectedAction?.environment,
          }}
          setStepNo={setStepNo}
          baseBreadcrumb={actionsBreadcrumbs}
          finalBreadcrumb={activateFxAccountBreadcrumb}
          pageHeaderTxt={`Activate ${labels.FX_ACCOUNT}`}
          actionButtonLabelTxt={`Activate ${labels.FX_ACCOUNT}`}
          performAnotherActionButtonTxt="Go To My Actions"
          action={actionType.ACTIVATE_FX_ACCOUNT.name}
        />
      )}
    </>
  );
};

export default Actions;
